import { createFileRoute } from "@tanstack/react-router";
import { CategoryLanding, categoryHead, productsQueryOptions } from "@/components/CategoryLanding";

const SLUG = "lasten-vaaterekki";
const H1 = "Lasten vaaterekki — Montessori-vaateteline";
const TITLE = "Lasten vaaterekki — Montessori-vaateteline | Montessori24";
const DESC =
  "Lasten vaaterekki lapsen korkeudella — Montessori-vaateteline, jolla taapero pukee itse. Koivupuu, ilmainen toimitus 3–7 pv, 30 pv palautusetu.";

const FAQS = [
  {
    q: "Miksi lapselle oma vaaterekki?",
    a: "Montessori-pedagogiikassa lapsi oppii itsenäisyyttä silloin kun ympäristö on hänen kokoisensa. Kun vaatteet ovat lapsen ulottuvilla omalla rekillä, hän voi itse valita päivän asun ja pukea sen — mikä kehittää päätöksentekoa ja hienomotoriikkaa.",
  },
  {
    q: "Minkä ikäiselle vaaterekki sopii?",
    a: "18 kk-vauvasta esikouluikään. Aluksi rekillä on pari valittua asua vanhemman kanssa; 3-vuotias jo hoitaa oman pukeutumisensa itsenäisesti.",
  },
  {
    q: "Kuinka paljon vaaterekki vie tilaa?",
    a: "Yleensä 60–80 cm leveä ja 100–120 cm korkea. Mahtuu lastenhuoneen nurkkaan tai vaatehuoneeseen. Osassa malleista on lisäksi alahylly kengille ja koreille.",
  },
];

export const Route = createFileRoute("/lasten-vaaterekki")({
  loader: ({ context }) => context.queryClient.ensureQueryData(productsQueryOptions),
  head: () => categoryHead({ slug: SLUG, title: TITLE, h1: H1, description: DESC, faqs: FAQS }),
  component: VaaterekkiPage,
});

function VaaterekkiPage() {
  return (
    <CategoryLanding
      slug={SLUG}
      eyebrow="Vaaterekit"
      title={H1}
      intro="Lapsen kokoinen vaaterekki muuttaa aamurutiinin: taapero valitsee itse vaatteensa, pukee ja tuntee ylpeyttä. Kestävää puuta, matala ja vakaa. Ihanteellinen Montessori-lastenhuoneeseen."
      kauppaCategory="storage"
      match={(t) => /vaate|vaaterekki|vaateteline|clothing\s*rack|kids\s*rack|hanger\s*rack|clothes\s*rail/i.test(t)}
      relatedChips={[
        { label: "Vaaterekki (yleisopas)", to: "/vaaterekki" },
        { label: "Kaikki säilytys", to: "/kauppa" },
        { label: "Oppimistornit", to: "/oppimistorni" },
        { label: "Kalusteopas", to: "/montessori-koulu/montessori-kalusteet-kotiin" },
      ]}
      body={[
        {
          heading: "Pieni muutos, iso vaikutus arjessa",
          paragraphs: [
            "Aikuisen kaappi on lapselle mahdoton: naulakot ovat 150 cm korkealla, ovet raskaita ja vaatteet aikuisen valitsemia. Lapsen kokoinen vaaterekki laittaa 5–8 asua taaperon ulottuville — sopiva määrä, josta lapsi osaa valita ilman ylikuormitusta.",
            "Vanhemmalle tämä tarkoittaa, että aamu ei ole tappelua siitä mitä lapsi pukee. Lapsi valitsee, pukee ja on ylpeä lopputuloksesta. Sivuvaikutuksena: hienomotoriikka kehittyy nopeammin, sillä nappien ja vetoketjujen käyttö on jokapäiväinen harjoitus.",
          ],
        },
        {
          heading: "Mihin kiinnittää huomiota vaaterekkiä valitessa",
          paragraphs: [
            "Vakaus: leveä alusta tai jalkojen välistä poikittainen tuki estävät kaatumisen kun lapsi vetää vaatetta pois.",
            "Korkeus: naulakon on oltava lapsen olkapäätä matalampi — muuten hän ei saa vaatetta pois henkarilta.",
            "Materiaali: koivuvaneri tai massiivipuu kestää lapsen käytön vuosia. Metallirekit ovat kylmiä ja usein huonosti tasapainossa.",
          ],
        },
      ]}
      faqs={FAQS}
    />
  );
}